import React from 'react';
import PropTypes from 'prop-types';

import WarningIcon from '@material-ui/icons/Warning';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import useStyles from './style';

export const AlertDialog = ({
  onCancel,
  onAccept,
  title,
  showModal,
  onCancelText,
  onAcceptText,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={showModal}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{ root: classes.dialogContainer }}
    >
      <DialogTitle className={classes.title} id="responsive-dialog-title">
        {title}
      </DialogTitle>
      <div className={classes.iconContainer}>
        <WarningIcon className={classes.icon} />
      </div>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={onAccept} color="primary">
          { onAcceptText }
        </Button>
        <Button onClick={onCancel} color="primary">
          { onCancelText }
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AlertDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  onCancelText: PropTypes.string.isRequired,
  onAcceptText: PropTypes.string.isRequired,
};
